var exports = {
  "kL": "xa15a2ab7--2e80f8--container",
  "Kk": "xa15a2ab7--2e80f8--icon",
  "NX": "xa15a2ab7--2e80f8--icon--opened",
  "x6": "xa15a2ab7--2e80f8--button",
  "nf": "xa15a2ab7--2e80f8--link",
};

module.exports = exports;
